import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';
Swiper.use([ Navigation ]);

export default class SlidingGallery {
    constructor() {
        if($('.js-sliding-gallery').length) {
            const $slider = $('.js-sliding-gallery');

            const slidingGallery = new Swiper($slider[0], {
                breakpoints: {
                    768: {
                        slidesPerView: 3
                    },
                    1024: {
                        slidesPerView: 4
                    }
                },
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                slidesPerView: 2,
                spaceBetween: 20,
                speed: 300
            });

            slidingGallery.init();
        };
    };
};
